// Core packages
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Third party packages

// Custom packages - Misc
import { RoleGuard } from 'src/app/shared/guards/role.guard';

// Custom packages - Component
import { DdtsListComponent } from 'src/app/modules/ddts/pages/ddts-list/ddts-list.page';
import { ChecklistDetailComponent } from './pages/checklist-detail/checklist-detail.page';
import { ChecklistListComponent } from './pages/checklist-list/checklist-list.page';
import { DdtDetailComponent } from './pages/ddt-detail/ddt-detail.page';


const routes: Routes = [
  {
    path: 'list',
    component: DdtsListComponent,
    canActivate: [RoleGuard],
    data: {
      permissions: ['canReadDocumentsList']
    },
  },
  {
    path: 'detail/:ddtId',
    component: DdtDetailComponent,
    canActivate: [RoleGuard],
    data: {
      permissions: ['canCreateDocuments']
    },
  },
  {
    path: 'checklist',
    component: ChecklistListComponent,
    canActivate: [RoleGuard],
    data: {
      permissions: ['canReadDocumentsList']
    },
  },
  {
    path: 'checklist-detail/:ddtId',
    component: ChecklistDetailComponent,
    canActivate: [RoleGuard],
    data: {
      permissions: ['canReadDocumentsList']
    },
  },
  {
    path: '**',
    redirectTo: 'it/errors/404'
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class DdtsRoutingModule { }
